import { Listing, ListingNote } from 'src/WebApiController';

export type InventoryMetrics = {
  listingCount: number;
  ticketCount: number;
  allAvailableTickets?: number; // Including stubhub listings
};

export type ListingWithComp = Listing & {
  isCompListing?: boolean;
  listingNotes?: ListingNote[] | null;
  isFanInventory?: boolean | null;
  validPurchaseQuantities?: number[];
};

// Enum for listing tile item types
export enum ListingTileItemType {
  OwnListing = 'ownListing',
  SingleComp = 'singleComp',
  Identical = 'identical',
  PriceRange = 'priceRange',
  Floor = 'floor',
  Ceiling = 'ceiling',
}

// Discriminated union types using enum
export type IdenticalCompListingGroup = {
  type: ListingTileItemType.Identical;
  compListings: ListingWithComp[];
};
export type SingleCompListing = {
  type: ListingTileItemType.SingleComp;
  listing: ListingWithComp;
};

export type RangedCompListingGroupItem =
  | IdenticalCompListingGroup
  | SingleCompListing;

export type PriceRangeCompListingGroup = {
  type: ListingTileItemType.PriceRange;
  groupItems: RangedCompListingGroupItem[];
  lowerPrice: number;
  upperPrice: number;
};

export type FloorDividerItem = {
  type: ListingTileItemType.Floor;
  price: number;
  currency?: string;
};

export type CeilingDividerItem = {
  type: ListingTileItemType.Ceiling;
  price: number;
  currency?: string;
};

// Union type for divider items
export type DividerItem = FloorDividerItem | CeilingDividerItem;

// Own listing type
export type OwnListingTileItem = {
  type: ListingTileItemType.OwnListing;
  listing: ListingWithComp;
};

// Main union type for tile items
export type ListingTileItem =
  | OwnListingTileItem
  | SingleCompListing
  | PriceRangeCompListingGroup
  | DividerItem;
